import { Navigate } from "react-router-dom";

// The agents catalog on /models is the start screen; "/" is just an alias for it.
const HomePage = () => <Navigate to="/models" replace />;

export default HomePage;
